module.exports = __webpack_public_path__ + "img/icon_recruit_welfare_01.a07c243c.png";